document.addEventListener('DOMContentLoaded', function () {
  const estimateEls = document.querySelectorAll('[data-delivery-estimate]');
  if (!estimateEls.length) return;

  function formatDate(date) {
    return date.toLocaleDateString('en-US', {
      weekday: 'short',
      month: 'short',
      day: 'numeric'
    });
  }

  function addCalendarDays(date, days) {
    const result = new Date(date);
    result.setDate(result.getDate() + days);
    return result;
  }

  estimateEls.forEach(function (estimateEl) {
    const startEl = estimateEl.querySelector('[data-delivery-start]');
    const endEl = estimateEl.querySelector('[data-delivery-end]');

    if (!startEl || !endEl) return;

    const today = new Date();

    const startDate = addCalendarDays(today, 5);
    const endDate = addCalendarDays(today, 7);

    startEl.textContent = formatDate(startDate);
    endEl.textContent = formatDate(endDate);
  });
});